import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import LogRocket from 'logrocket';
import { GoogleOAuthProvider } from '@react-oauth/google';

import App from 'App';
import store from 'state/store';
import { browserHistory } from 'utils/functions';

import './index.css';
import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_LOGROCKET_KEY) {
  LogRocket.init(process.env.REACT_APP_LOGROCKET_KEY);
}

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}>
      <Provider store={store}>
        <Router history={browserHistory}>
          <App />
        </Router>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
